import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class ResultEndpointService {
  readonly #service = inject(ServicesService);

  groupResult(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ) {
    return this.#service.thorEndpoint(
      `group/${groupCode}/score/${arrangementCode}/${contentIdentifier}`,
    );
  }

  bulkDeleteGroupResult(groupCode: string) {
    return this.#service.thorEndpoint(`group/${groupCode}/delete-bulk`);
  }
}
